import { AppModes } from '@shared/services/app.service';
import { Subject } from 'rxjs';

type VisibilityConfigType = {
  distributor: AppModes;
  producer: AppModes;
  client: AppModes;
  distributor_producer: AppModes[];
  producer_client: AppModes[];
  distributor_client: AppModes[];
  all: AppModes[];
};

const visibilityConfig: VisibilityConfigType = {
  distributor: AppModes.DISTRIBUTOR,
  producer: AppModes.PRODUCER,
  client: AppModes.CLIENT,
  distributor_producer: [AppModes.PRODUCER, AppModes.DISTRIBUTOR],
  distributor_client: [AppModes.CLIENT, AppModes.DISTRIBUTOR],
  producer_client: [AppModes.CLIENT, AppModes.PRODUCER],
  all: [AppModes.CLIENT, AppModes.PRODUCER, AppModes.DISTRIBUTOR],
};

export type MenuItem = {
  title: string;
  className: string;
  visibility: AppModes[];
  path?: string;
  counter$?: Subject<number>;
  counterName?: CounterNamesEnum;
};

export type SecondaryMenuItem = {
  title: string;
  path?: string;
  visibility?: AppModes[];
};

export enum CounterNamesEnum {
  REQUESTS = 'requests',
  SUPPORT = 'support',
  NOTIFICATION = 'notification',
  PROPOSALS = 'proposals',
}

export type LangSelectItem = {
  title: string;
  value: string;
}

export const SidebarMenuItems: MenuItem[] = [
  {
    title: $localize`Установки`,
    className: 'devices',
    path: 'devices',
    visibility: visibilityConfig.all,
  },
  {
    title: $localize`Дистрибьюторы`,
    className: 'distributors',
    path: 'distributors',
    visibility: [visibilityConfig.producer],
  },
  {
    title: $localize`Госпитали`,
    className: 'hospitals',
    path: 'clients',
    visibility: visibilityConfig.distributor_producer,
  },
  {
    title: $localize`Обращения`,
    className: CounterNamesEnum.REQUESTS,
    visibility: [visibilityConfig.distributor, visibilityConfig.producer],
    counterName: CounterNamesEnum.REQUESTS,
    path: 'requests',
  },
  {
    title: $localize`Задачи`,
    className: 'tasks',
    visibility: [visibilityConfig.client],
    path: 'tasks',
  },
  {
    title: $localize`Помещения`,
    className: 'rooms',
    visibility: [visibilityConfig.client],
    path: 'departments',
  },
  {
    title: $localize`Пользователи установок`,
    className: 'device-users',
    visibility: [visibilityConfig.client],
    path: 'performers',
  },
  {
    title: $localize`Поддержка`,
    className: CounterNamesEnum.SUPPORT,
    visibility: [visibilityConfig.client],
    counterName: CounterNamesEnum.SUPPORT,
    path: 'requests',
  },
  {
    title: $localize`Уведомления`,
    className: CounterNamesEnum.NOTIFICATION,
    visibility: visibilityConfig.all,
    counterName: CounterNamesEnum.NOTIFICATION,
    path: 'notifications',
  },
  {
    title: $localize`Статистика`,
    className: 'statistics',
    visibility: visibilityConfig.all,
    path: 'statistics',
  },
  {
    title: $localize`Сотрудники`,
    className: 'staff',
    visibility: visibilityConfig.all,
    path: 'users',
  },
  {
    title: $localize`Отзывы и предложения`,
    className: CounterNamesEnum.PROPOSALS,
    path: 'proposals',
    visibility: visibilityConfig.all,
    counterName: CounterNamesEnum.PROPOSALS,
  },
  {
    title: $localize`Обновления`,
    className: 'updates',
    path: 'updates',
    visibility: [visibilityConfig.producer],
  },
];

export const sidebarSecondaryMenuItem: SecondaryMenuItem[] = [
  {
    title: $localize`Данные`,
    path: '/cp/devices',
    visibility: visibilityConfig.all,
  },
  {
    title: $localize`Настройки`,
    path: '/cp/devices',
    visibility: visibilityConfig.all,
  },
];

export const langSelectList: LangSelectItem[] = [
  {
    title: 'Русский',
    value: 'ru'
  }, {
    title: 'English',
    value: 'en'
  }
];
